export function normalizeWhitespaces(text: string): string {
    return text.replace(/[\u202F\u00A0\u2000\u2001\u2003]/g, ' ');
}

// replace dot with commas
const replaceDotWithCommas = (num: string) => num.replace('.', ',');

// return number with provided character as thousand separator
const thousandSeparator = (separator: string) => (num: string) =>
    num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);

const normalizeNumber = (text: string) => replaceDotWithCommas(normalizeWhitespaces(text));

// custom format override method for es-ES.
const formatESNumber = (text: string) => thousandSeparator('.')(normalizeNumber(text));

// custom format override method for pl-PL.
const formatPLNumber = (text: string) => thousandSeparator(' ')(normalizeNumber(text));

// mapper for custom formatters
const customFormatter = {
    'es-ES': formatESNumber,
    'pl-PL': formatPLNumber,
};

export const formatPrice = (countryCode: string, currency: string, price: number) => {
    if (countryCode === '' || currency === '') {
        return String(price);
    }

    const hasDecimalPlaces = price % 1 !== 0;

    const num = new Intl.NumberFormat(countryCode, {
        style: 'currency',
        currency,
        minimumFractionDigits: hasDecimalPlaces ? 2 : 0,
        maximumFractionDigits: 2,
    }).format(price);

    // see if the country code has any custom override method else return the value
    return customFormatter[countryCode] ? customFormatter[countryCode](num) : num;
};

export const capitalize = (input: string) => {
    if (!input) {
        return input;
    }

    return `${input[0].toLocaleUpperCase()}${input.substring(1)}`;
};

export const getCountry = (countryCode: string) => (countryCode || '').substring(countryCode.length - 2).toLowerCase();
